module.exports = __webpack_public_path__ + "img/events-4.e6652286.jpg";